export { default } from "./DynamicForm";


